import React from 'react';
import Icon from '../icone/icon';
import Tooltip from '../tooltips/tooltip';
import { GlobalContext } from '../../../utils/globalprovider.js';

class Button extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.display === false) {
      return <></>;
    }

    if (this.props.tooltip == null)
      return (
        <Icon
          {...this.props}
          image={this.props.image}
          disable={this.props.disable}
          button={true}
          datas={this.props.datas}
          border={this.props.border}
          alt={this.props.alt}
          onKeyDown={this.props.onKeyDown}
        />
      );
    else
      return (
        <Tooltip
          text={
            this.context.language === 'fr'
              ? this.props.tooltip.fr
              : this.props.tooltip.en
          }
          onClick={this.props.onClick}
          onKeyDown={this.props.onKeyDown}
        >
          <Icon
            border={this.props.toggle && this.props.toggled}
            {...this.props}
            image={this.props.image}
            disable={this.props.disable}
            button={true}
            datas={this.props.datas}
            onClick={this.props.onClick}
            inverseColor={this.props.inverseColor}
            onKeyDown={this.props.onKeyDown}
            alt={this.props.alt}
          />
        </Tooltip>
      );
  }
}
Button.defaultProps = {
  tooltip: null,
  datas: null,
  toogle: false,
  toogled: false,
};

export default Button;
